import React, { useEffect, useImperativeHandle, forwardRef } from 'react'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Icon from 'src/@core/components/icon'
import styles from './wifi-info.module.scss'
import { useTranslation } from 'src/utils/i18n'

function WifiDrawer({ data }, ref) {
  const [state, setState] = React.useState({
    right: false
  })

  const { t } = useTranslation('common')

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, [anchor]: open })
  }

  function toggleDrawerParent(anchor, open) {
    setState({ ...state, [anchor]: open })
  }

  useImperativeHandle(ref, () => ({
    // 暴露给父组件的方法
    toggleDrawerParent
  }))

  const list = anchor => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300 }}
      role='presentation'
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className={styles.contactsInfo}>
        <div className={styles.arrow}>
          <Icon icon='mdi:chevron-right' />
        </div>

        <div className={styles.top}>
          <div className={styles.pic}>
            <Icon icon='ic:outline-wifi' fontSize='1.25rem' color='#888888'></Icon>
          </div>
          <div className={styles.name}>{data.name}</div>
        </div>
        <div className={styles.contentBox}>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='ic:baseline-connect-without-contact' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('CONNECTED AT')}</span>
              <span className={styles.number}>{data.connectedAt}</span>
            </div>
          </div>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='ic:twotone-more-time' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('USAGE TIME')}</span>
              <span className={styles.number}>{data.usageTime}</span>
            </div>
          </div>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='mdi:latitude' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('Latitude')}</span>
              <span className={styles.number}>{data.latitude}</span>
            </div>
          </div>
          <div className={styles.containers}>
            <div className={styles.icon}>
              <Icon icon='tabler:world-longitude' />
            </div>
            <div className={styles.text}>
              <span className={styles.name}>{t('Longitude')}</span>
              <span className={styles.number}>{data.longitude}</span>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )

  return (
    <div>
      <Drawer anchor={'right'} open={state['right']} onClose={toggleDrawer('right', false)}>
        {list('right')}
      </Drawer>
    </div>
  )
}

WifiDrawer = forwardRef(WifiDrawer)

export default WifiDrawer
